import React, { useState } from "react";
import MovieList from "./MovieList";

function Randomizer() {
  const [randomMovie, setRandomMovie] = useState(
    MovieList[Math.floor(Math.random() * MovieList.length)]
  );
  const [clickCount, setClickCount] = useState(1);

  const reviewedMovies = MovieList.filter((movie) => movie.synopsis !== "");

  const showMovie = () => {
    const movie =
      reviewedMovies[Math.floor(Math.random() * reviewedMovies.length)];
    setRandomMovie(movie);
    setClickCount((prevCount) => prevCount + 1);
  };

  const {
    name: movieName,
    poster: moviePoster,
    rating: movieRating,
    year: movieYear,
    synopsis: movieSynopsis,
    runtime,
    rated: MPAA,
    pairs,
    noPairs,
    drinkRecipe: ingredients,
    bulletOne,
    bulletTwo,
  } = randomMovie;

  // Clean the pairs and noPairs values to remove leading and trailing periods
  const cleanedPairs = pairs ? pairs.replace(/^[\.]+|[\.]+$/g, "") : "";
  const cleanedNoPairs = noPairs ? noPairs.replace(/^[\.]+|[\.]+$/g, "") : "";

  // Pairing display logic
  const showPairs =
    cleanedPairs && ingredients ? (
      <span className="pairsWithRandomText">
        <strong>Pairs well with {cleanedPairs}</strong>: {ingredients}
      </span>
    ) : cleanedNoPairs ? (
      <span className="pairsWithRandomText">
        <strong>Pairs well with {cleanedNoPairs}</strong>
      </span>
    ) : (
      ""
    );

  const showRandomLimit =
    clickCount >= 4
      ? `No more random selections. The movie gods have spoken, and you will watch
        ${movieName}.`
      : "";

  return (
    <div className="movieBackgroundRandom">
      <p className="randomizerText">
        Tired of <span className="green">endlessly scrolling?</span>
      </p>
      <p className="randomizerSubtext">
        Click the <span className="green">randomizer</span> and commit to
        whatever movie comes up
      </p>

      <div className="randomizerLimit">{showRandomLimit}</div>

      {/* Button is now above the movie */}
      {clickCount < 4 && (
        <div className="randomButtonDiv">
          <button className="randomButton" onClick={showMovie}>
            Give me a movie!
          </button>
        </div>
      )}

      <div className="randomMovieContainer">
        <div className="randomCard">
          <div className="randomContainer">
            <div className="imageContainer">
              <div className="img-reviewed-random">
                <img
                  className="img-img-reviewed-random"
                  src={moviePoster}
                  alt="movie cover"
                />
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://www.google.com/search?q=where+to+watch+${movieName}`}
                >
                  <div className="img-overlay-reviewed-random">
                    <div className="img-title-reviewed-random">Watch Me!</div>
                    <p className="img-description-reviewed-random">
                      Click to find where
                    </p>
                  </div>
                </a>
              </div>
            </div>

            <div className="scrollableContainer">
              <div className="infoContainer">
                <p className="movieName">{movieName}</p>
                <div className="ratingsContainer">
                  <p id="MPAA">{MPAA}</p>
                  <p>
                    <i className="far fa-clock"></i> {runtime}
                  </p>
                  <p>{movieYear}</p>
                  <span
                    role="img"
                    aria-label="Emoji"
                    style={{ verticalAlign: "middle" }}
                  >
                    🍺{movieRating}
                  </span>
                </div>

                <div className="synopsis">
                  <p>
                    {movieSynopsis === ""
                      ? "Hey there fellow slobs! We'll have a review and drink pairing for ya shortly!"
                      : movieSynopsis}
                  </p>
                </div>

                <p className="randomSpecialFeatures">
                  <strong>
                    <u>Special Features</u>
                  </strong>
                </p>
                <div className="randomBullets">
                  <p>&#x2022;{bulletOne}</p>
                  <p>&#x2022;{bulletTwo}</p>
                </div>

                <div className="pairsWithRandom">
                  <p>{showPairs}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Randomizer;
